/**
 *
 * UsersForm
 *
 */


import UsersForm from "pages/Settings/UsersView/UsersForm";
import {ON_VISIT} from "domain/Data/RequestType/constants";

const BP_SKOLKOVO_DEPT = '4213024313000'

export class UsersForm14852 extends UsersForm {

    getFields() {
        let fields = super.getFields()
        const departmentIndex = fields.findIndex((field) => field.name === 'department');
        fields[departmentIndex].visibleOptions = (currentValues, initialValues, mode, user, entities) => {
            const departments = entities.get('departments').valueSeq().toJS();
            return departments.filter(item => item.id !== BP_SKOLKOVO_DEPT).map((item) => item.id);
        }
        const availableRequestTypes = {
            name: 'availableRequestTypes',
            type: 'select',
            label: 'Доступные виды заявок',
            initialValue: (values, mode) => mode === 'add' ? [ON_VISIT] : values.availableRequestTypes,
            multiple: true,
            entityName: 'requestTypes',
            orderBy: 'name',
            rowBreakBefore: true,
            cached: true,
        }
        const defaultRequestType =
            {
                name: 'defaultRequestType',
                type: 'select',
                label: 'Вид заявки по умолчанию',
                entityName: 'requestTypes',
                initialValue: (values, mode) => mode === 'add' ? ON_VISIT : values.defaultRequestType,
                rowBreakBefore: true,
            }

        const rolesIndex = fields.findIndex((field) => field.name === 'roles');

        fields.splice(rolesIndex + 1, 0, availableRequestTypes)
        fields.splice(rolesIndex + 2, 0, defaultRequestType)

        return fields
    }
}